if (!customElements.get('cart-progress')) {
  class cartProgress extends HTMLElement {
    constructor() {
      super();

      this.cartTotal = parseFloat(this.dataset.cartTotal);
      this.freeShipPrice = this.dataset.freeshipPrice;
      this.progressBar = this.querySelector('.progress-bar');
      this.progressHeader = this.querySelector('.progress-bar-header');

      this.offerOnePrice = this.dataset.offerOne;
      this.offerTwoPrice = this.dataset.offerTwo;

      this.offerZeroText = this.dataset.freeshipPriceText;
      this.offerOneText = this.dataset.offerOneText;
      this.offerTwoText = this.dataset.offerTwoText;
 
      this.init();
    }

    initProgressBar = () => {
      // step 1
      let progressBarWidthZero = 0;
      if (this.freeShipPrice != '') {
          progressBarWidthZero = (parseInt(this.freeShipPrice)  - this.cartTotal) / parseInt(this.freeShipPrice) * 100;
          progressBarWidthZero = 100 - progressBarWidthZero;
          if(progressBarWidthZero >= 100) progressBarWidthZero = 100;
            this.querySelector('[data-mileston-zero]').style.setProperty('--progress',`${progressBarWidthZero.toFixed(2)}%`);
            this.querySelector('[data-mileston-zero]').style.setProperty('--firstLeft',`${progressBarWidthZero.toFixed(2)}%`);
        if(progressBarWidthZero >= 100) progressBarWidthZero = 100;
        }
      
      // step 2
      let progressBarWidthOne = 0;
      if (this.offerOnePrice != '') {
          progressBarWidthOne = (parseInt(this.offerOnePrice)  - this.cartTotal) / parseInt(this.offerOnePrice) * 100;
          progressBarWidthOne = 100 - progressBarWidthOne;
        if(progressBarWidthOne >= 100) progressBarWidthOne = 100;
        (progressBarWidthOne >= 100) ? this.querySelector('[data-mileston-one]').classList.add('filled') : this.querySelector('[data-mileston-one]').classList.remove('filled') ;
        if (this.freeShipPrice != '') { 
          if (progressBarWidthZero >= 100) {
            this.querySelector('[data-mileston-one]').style.setProperty('--progress',`${progressBarWidthOne.toFixed(2)}%`);
          } else {
            this.querySelector('[data-mileston-one]').style.setProperty('--progress',`0`);
          }
        }
        else {
            this.querySelector('[data-mileston-one]').style.setProperty('--progress',`${progressBarWidthOne.toFixed(2)}%`);
            this.querySelector('[data-mileston-one]').style.setProperty('--firstLeft',`${progressBarWidthOne.toFixed(2)}%`);
        }
      }

      // step 3
      let progressBarWidthTwo = 0;
      if (this.offerTwoPrice != '') {
        progressBarWidthTwo = (this.offerTwoPrice  - this.cartTotal) / this.offerTwoPrice * 100;
        progressBarWidthTwo = 100 - progressBarWidthTwo;
        if(progressBarWidthTwo >= 100) progressBarWidthTwo = 100;
        (progressBarWidthTwo >= 100) ? this.querySelector('[data-mileston-two]').classList.add('filled') : this.querySelector('[data-mileston-two]').classList.remove('filled') ;
        if (this.freeShipPrice != '' && this.offerOnePrice == '') { 
          if (progressBarWidthZero >= 100) {
            this.querySelector('[data-mileston-two]').style.setProperty('--progress',`${progressBarWidthTwo.toFixed(2)}%`); 
          } else {
            this.querySelector('[data-mileston-two]').style.setProperty('--progress',`0`); 
          }
        }
        else if (this.offerOnePrice != '') { 
          if (progressBarWidthOne >= 100) {
            this.querySelector('[data-mileston-two]').style.setProperty('--progress',`${progressBarWidthTwo.toFixed(2)}%`); 
          } else {
            this.querySelector('[data-mileston-two]').style.setProperty('--progress',`0`); 
          }
        }
        else {
            this.querySelector('[data-mileston-two]').style.setProperty('--progress',`${progressBarWidthTwo.toFixed(2)}%`);
            this.querySelector('[data-mileston-two]').style.setProperty('--firstLeft',`${progressBarWidthTwo.toFixed(2)}%`);
        }
      }

      // show remaining ammout text
      if (this.offerTwoPrice != '' && this.offerOnePrice != '' && this.freeShipPrice != '') { 
        if (progressBarWidthZero < 99.99) {
          let remainingPrice = (this.freeShipPrice - this.cartTotal) * 100;
          remainingPrice = theme.Currency.formatMoney(remainingPrice, theme.settings.moneyFormat);
          this.progressHeader.innerHTML = `You are <strong>${remainingPrice}</strong> away from a <strong>${this.offerZeroText}</strong>`; 
        } else if (progressBarWidthZero > 99.99 && progressBarWidthOne < 99.99) {
          let remainingPrice = (parseInt(this.offerOnePrice) - this.cartTotal) * 100;
          remainingPrice = theme.Currency.formatMoney(remainingPrice, theme.settings.moneyFormat);
          this.progressHeader.innerHTML = `You are <strong>${remainingPrice}</strong> away from a <strong>${this.offerOneText}</strong>`; 
        } else if (progressBarWidthOne > 99.99 && progressBarWidthTwo < 99.99) {
          let remainingPrice = (this.offerTwoPrice - this.cartTotal) * 100;
          remainingPrice = theme.Currency.formatMoney(remainingPrice, theme.settings.moneyFormat);
          this.progressHeader.innerHTML = `You are <strong>${remainingPrice}</strong> away from a <strong>${this.offerTwoText}</strong>`; 
        } else {
          this.progressHeader.innerHTML = `Congrats!✨ You've unlocked <strong>${this.offerTwoText}</strong>`; 
        }
      }
      else if (this.offerTwoPrice == '' && this.offerOnePrice != '' && this.freeShipPrice == '') {
        if (progressBarWidthOne < 99.99) {
          let remainingPrice = (parseInt(this.offerOnePrice) - this.cartTotal) * 100;
          remainingPrice = theme.Currency.formatMoney(remainingPrice, theme.settings.moneyFormat);
          this.progressHeader.innerHTML = `Add more <strong>${remainingPrice}</strong> to get <strong>${this.offerOneText}</strong>`; 
        } else {
          this.progressHeader.innerHTML = `Congrats!✨ You've unlocked <strong>${this.offerOneText}</strong>`; 
        }
      }
      else if (this.offerTwoPrice != '' && this.offerOnePrice == '' && this.freeShipPrice == '') {
        if (progressBarWidthTwo < 99.99) {
          let remainingPrice = (this.offerTwoPrice - this.cartTotal) * 100;
          remainingPrice = theme.Currency.formatMoney(remainingPrice, theme.settings.moneyFormat);
          this.progressHeader.innerHTML = `Add more <strong>${remainingPrice}</strong> to get <strong>${this.offerTwoText}</strong>`; 
        } else {
          this.progressHeader.innerHTML = `Congrats!✨ You've unlocked <strong>${this.offerTwoText}</strong>`; 
        }
      }
      else if (this.offerOnePrice == '' && this.offerTwoPrice != '' && this.freeShipPrice != '') {
        if (progressBarWidthZero < 99.99) {
          let remainingPrice = (this.freeShipPrice - this.cartTotal) * 100;
          remainingPrice = theme.Currency.formatMoney(remainingPrice, theme.settings.moneyFormat);
          this.progressHeader.innerHTML = `You are <strong>${remainingPrice}</strong> away from a <strong>${this.offerZeroText}</strong>`; 
        } else if (progressBarWidthZero > 99.99 && progressBarWidthTwo < 99.99) {
          let remainingPrice = (parseInt(this.offerTwoPrice) - this.cartTotal) * 100;
          remainingPrice = theme.Currency.formatMoney(remainingPrice, theme.settings.moneyFormat);
          this.progressHeader.innerHTML = `You are <strong>${remainingPrice}</strong> away from a <strong>${this.offerTwoText}</strong>`; 
        } else {
          this.progressHeader.innerHTML = `Congrats!✨ You've unlocked <strong>${this.offerTwoText}</strong>`; 
        }
      }
      else if (this.offerOnePrice != '' && this.offerTwoPrice != '' && this.freeShipPrice == '') {
        if (progressBarWidthOne < 99.99) {
          let remainingPrice = (this.offerOnePrice - this.cartTotal) * 100;
            remainingPrice = theme.Currency.formatMoney(remainingPrice, theme.settings.moneyFormat);
          this.progressHeader.innerHTML = `You are <strong>${remainingPrice}</strong> away from a <strong>${this.offerOneText}</strong>`; 
        } else if (progressBarWidthOne > 99.99 && progressBarWidthTwo < 99.99) {
          let remainingPrice = (parseInt(this.offerTwoPrice) - this.cartTotal) * 100;
            remainingPrice = theme.Currency.formatMoney(remainingPrice, theme.settings.moneyFormat);
          this.progressHeader.innerHTML = `You are <strong>${remainingPrice}</strong> away from a <strong>${this.offerTwoText}</strong>`; 
        } else {
          this.progressHeader.innerHTML = `Congrats!✨ You've unlocked <strong>${this.offerTwoText}</strong>`; 
        }
      }
      else if (this.offerOnePrice != '' && this.offerTwoPrice == '' && this.freeShipPrice != '') {
        if (progressBarWidthZero < 99.99) {
          let remainingPrice = (this.freeShipPrice - this.cartTotal) * 100;
            remainingPrice = theme.Currency.formatMoney(remainingPrice, theme.settings.moneyFormat);
          this.progressHeader.innerHTML = `You are <strong>${remainingPrice}</strong> away from a <strong>${this.offerZeroText}</strong>`; 
        } else if (progressBarWidthZero > 99.99 && progressBarWidthOne < 99.99) {
          let remainingPrice = (parseInt(this.offerOnePrice) - this.cartTotal) * 100;
            remainingPrice = theme.Currency.formatMoney(remainingPrice, theme.settings.moneyFormat);
          this.progressHeader.innerHTML = `You are <strong>${remainingPrice}</strong> away from a <strong>${this.offerOneText}</strong>`; 
        } else {
          this.progressHeader.innerHTML = `Congrats!✨ You've unlocked <strong>${this.offerOneText}</strong>`; 
        }
      }
        else {
        if (progressBarWidthZero < 99.99) {
          let remainingPrice = (this.freeShipPrice - this.cartTotal) * 100;
            remainingPrice = theme.Currency.formatMoney(remainingPrice, theme.settings.moneyFormat);
          this.progressHeader.innerHTML = `Add more <strong>${remainingPrice}</strong> to get <strong>${this.offerZeroText}</strong>`; 
        } else {
          this.progressHeader.innerHTML = `Congrats!✨ You've unlocked <strong>${this.offerZeroText}</strong>`; 
        }
      }
    }

    updateCartTotal = () => {
      document.addEventListener('cart:updated', (e) => {
        if(e.detail.cart.total_price){
          this.cartTotal = e.detail.cart.total_price / 100;
          this.initProgressBar();
        }
        if (e.detail.cart.item_count == 0) {
          this.style.display = 'none';
        } else {
          this.style.display = null;
        }
      })
      document.addEventListener('ajaxProduct:added', (event) => {
        fetch('/cart.json',{method:'GET'}).then(res => res.json()).then(res => {
          this.cartTotal = res.total_price / 100;
          this.initProgressBar();
        })
      
     
      });

    }
    updateQuickCartTotal = () => {
      this.addcartEle = document.querySelector('.drawer__inner [data-subtotal]');
			if (this.addcartEle) { 
				this.cartUpdateChangeMutation = new MutationObserver(() => {
          fetch('/cart.json',{method:'GET'}).then(res => res.json()).then(res => {
            this.cartTotal = res.total_price / 100;
            this.initProgressBar();
            if (res.item_count == 0) {
              this.style.display = 'none';
            } else {
              this.style.display = null;
            }
          })
				});
				this.cartUpdateChangeMutation.observe(this.addcartEle, {childList:true,attributes:true})
			}

    }

    init = () => {
      this.initProgressBar();
      this.updateCartTotal();
      this.updateQuickCartTotal();
    }
  }
  customElements.define('cart-progress',cartProgress);
}